// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".32db24dd54aab5a440768c674b6386a915cf3846.chunk.js";
};